import type { ReactNode } from 'react';
import { ConfigurationContext, type ConfigurationContextValue } from './configuration-context';

/** Supplies the session client, app id and scope to the configuration hooks below it. */
export function ConfigurationProvider({
  value,
  children,
}: {
  value: ConfigurationContextValue;
  children: ReactNode;
}) {
  return <ConfigurationContext value={value}>{children}</ConfigurationContext>;
}
